import * as React from 'react';

import cn from 'classnames';

import {
	DmcaFooter,
	DmcaForm,
	DmcaHeader,
} from '@common/containers/Dmca/components';
import { IDmcaPageProps } from '@common/containers/Dmca/types';

import * as s from './DmcaPage.scss';

export const DmcaPage = (props: IDmcaPageProps) => {
	const {
		classNames: {
			content: contentClassName,
		},
	} = props;

	return (
		<div className={s.block}>
			<DmcaHeader {...props}/>

			<div className={cn(s.content, contentClassName)}>
				<DmcaForm {...props}/>
			</div>

			<DmcaFooter {...props}/>
		</div>
	);
};
